import React, { createContext, useContext, useState, useEffect } from "react";
import * as Sentry from "@sentry/react";
import Client from "~/apiClient";
import { type GlobalMessage } from "~/schemas/admin";

type GlobalContextType = {
  globalMessages: GlobalMessage[] | null;
  loading: boolean;
};

const GlobalContext = createContext<GlobalContextType | undefined>(undefined);

export const GlobalProvider = ({ children }: { children: React.ReactNode }) => {
  const [globalMessages, setGlobalMessages] = useState<GlobalMessage[] | null>(
    null
  );
  const [loading, setLoading] = useState(true);

  const client = new Client();

  const fetchGlobalMessages = async () => {
    setLoading(true);
    try {
      const globalMessages = await client.getEnabledGlobalMessages();
      setGlobalMessages(globalMessages);
    } catch (error) {
      Sentry.captureException(error);
      setGlobalMessages(null);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchGlobalMessages();
  }, []);

  return (
    <GlobalContext.Provider value={{ globalMessages, loading }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => {
  const ctx = useContext(GlobalContext);
  if (!ctx) throw new Error("useGlobal must be used within GlobalProvider");
  return ctx;
};
